// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ICtv","top":"styles_top__1eWTC"};